(function(){
    'use strict'

    angular
    .module('app.companias')
    .controller('SeleccionarCompania', SeleccionarCompania);

    SeleccionarCompania.$inject = ['$animationsSrv', 'CompaniasService', 'logger', '$location', 'UserInfoService'];

    function SeleccionarCompania($animationsSrv, CompaniasService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        const PERMISO_ID = 19;

        vm.companias = [];
        vm.title = 'Companias';

        vm.selectCompania = function(compania){
            
            //UserInfoService.setCompania(compania);

            const permisoPaginaInicioOrdenes = UserInfoService.getPermisos(PERMISO_ID);
            let path = '';
            
            if(permisoPaginaInicioOrdenes.ver === true)
            {
                path = '/ordenes';
            }
            else
            {
                path = '/principal';
            }
            

            $location.path(path);

            logger.info('compañia seleccionada. ' + compania.nombre);
        };

        getAll();

        function getAll(){

            var promise = CompaniasService.getAll();

            promise
            .then(function(companias){

                if(companias > 1)
                {
                    vm.companias = companias;
                    logger.info('Selecciona la compañia.');                    
                }
                else{
                    if(companias[0])
                    {
                        vm.selectCompania(companias[0]);
                        logger.info('Compañia seleccionada automaticamente.');
                    }
                }

            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        UserInfoService.setToken(null);
                        break;
                
                    default:
                        logger.error('Error al obtener las companias.');
                        break;
                }
            });
        };

    }
})();